import SeamlyBaseError from './seamly-base-error'

export default class SeamlyUnauthorizedError extends SeamlyBaseError {
  constructor(originalError, ...params) {
    super(originalError, ...params)

    this.name = 'SeamlyUnauthorizedError'
    this.langKey = 'errors.general'
    this.action = 'reset'
  }
}
